import React, { useCallback, useContext } from 'react'
import ImagesContext from 'app/react/components/images/ImagesContext'
import { debounce } from 'lodash'

export default function useFilter () {

  const {
    categories,
    setActiveSearch,
    setActiveCategories,
    setActivePage
  } = useContext(ImagesContext)

  const setSearch = useCallback(debounce((e) => {
    setActiveSearch(e.target.value)
    setPage(1)
  }, 500), [])

  const setCategories = (i) => {
    setActiveCategories(categories[i].term_id)
    setPage(1)
  }

  const setPage = (page) => {
    setActivePage(page)
  }

  return {
    setSearch,
    setCategories,
    setPage
  }
}